export const customMessages = {
  'nome': {
    'string.base': '(Nome) deve ser um texto',
    'string.empty': '(Nome) é um campo obrigatório',
    'string.min': '(Nome) deve ter no mínimo 3 caracteres',
    'string.max': '(Nome) deve ter no máximo 100 caracteres',
    'any.required': '(Nome) é um campo obrigatório',
  },
  'cpf': {
    'string.empty': '(CPF) é um campo obrigatório',
    'string.min': '(CPF) deve ter no mínimo 11 caracteres',
    'string.max': '(CPF) deve ter no máximo 14 caracteres',
    'any.required': '(CPF) é um campo obrigatório',
  },
  'endereco': {
    'string.empty': '(Endereço) deve ser um texto',
    'string.base': '(Endereço) deve ser um texto',
    'string.min': '(Endereço) deve ter no mínimo 3 caracteres',
    'string.max': '(Endereço) deve ter no máximo 100 caracteres',
    'any.required': '(Endereço) é um campo obrigatório',
  },
  'bairro': {
    'string.base': '(Bairro) deve ser um texto',
    'string.empty': '(Bairro) deve ser um texto',
    'string.min': '(Bairro) deve ter no mínimo 3 caracteres',
    'string.max': '(Bairro) deve ter no máximo 100 caracteres',
    'any.required': '(Bairro) é um campo obrigatório',
  },
  'numero': {
    'string.base': '(Número) deve ser um texto',
    'string.empty': '(Número) deve ser um texto',
    'string.max': '(Número) deve ter no máximo 10 caracteres',
    'any.required': '(Número) é um campo obrigatório',
  },
  'cidade': {
    'string.base': '(Cidade) deve ser um texto',
    'string.empty': '(Cidade) deve ser um texto',
    'string.min': '(Cidade) deve ter no mínimo 3 caracteres',
    'string.max': '(Cidade) deve ter no máximo 100 caracteres',
    'any.required': '(Cidade) é um campo obrigatório',
  },
  'uf': {
    'string.base': '(UF) deve ser um texto',
    'string.empty': '(UF) é um campo obrigatório',
    'string.min': '(UF) deve ter no mínimo 2 caracteres',
    'string.max': '(UF) deve ter no máximo 2 caracteres',
    'any.required': '(UF) é um campo obrigatório',
  },
  'cep': {
    'string.empty': '(CEP) é um campo obrigatório',
    'string.min': '(CEP) inválido',
    'string.max': '(CEP) inválido',
    'any.required': '(CEP) é um campo obrigatório',
  },
  'email': {
    'string.base': '(Email) deve ser um texto',
    'string.empty': '(Email) deve ser um texto',
    'string.email': '(Email) deve ser um endereço de email válido',
    'any.required': '(Email) é um campo obrigatório',
  },
  'receita': {
    'number.base': '(Nº Receita) deve ser um número.',
    'number.empty': '(Nº Receita) deve ser preenchido.',
    'number.integer': '(Nº Receita) deve ser um número inteiro.',
    'any.required': '(Nº Receita) é obrigatório.'
  },
  'quantidadeReceita': {
    'number.base': '(Quant. receita) deve ser um número.',
    'number.empty': '(Quant. receita) deve ser preenchido.',
    'number.integer': '(Quant. receita) deve ser um número inteiro.',
    'any.required': '(Quant. receita) é obrigatório.'
  },
  'art': {
    'string.empty': '(Nº ART / TRT Atual) é um campo obrigatório',
    'string.min': '(Nº ART / TRT Atual) deve ter no mínimo 100 caracteres',
    'string.max': '(Nº ART / TRT Atual) deve ter no máximo 100 caracteres',
    'any.required': '(Nº ART / TRT Atual) é um campo obrigatório',
  },
};